import { useState } from 'react';

import { Flex, Grid, GridItem, Image, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Playlist } from '~/@types/tsl-types';
import { useScreenDetector } from '~/hooks/useScreenDetector';
import { useSetSelectedPlaylistIdValue } from '~/store/slices/playlist-hook';
import { usePlaylistsFoundSelector } from '~/store/slices/search-hook';

type Props = {
  title: string;
  linkText: string;
  playlists?: Playlist[];
};

function Playlists({ title, linkText, playlists }: Props) {
  const { t } = useTranslation('common');
  const { isDesktop } = useScreenDetector();
  const [maxDisplay, setMaxDisplay] = useState(isDesktop ? 5 : 3);
  const setSelectedPlaylistIdValue = useSetSelectedPlaylistIdValue();
  const playlistFound = usePlaylistsFoundSelector();

  return (
    <Stack minW='100%'>
      <Flex direction='row' justifyContent='space-between' minW='100%' mb={3}>
        <Text
          fontSize='18px'
          fontWeight='600'
          css={{
            '&:first-letter': {
              textTransform: 'uppercase',
            },
          }}
        >
          {title}
        </Text>
        {maxDisplay === Infinity ? (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(isDesktop ? 5 : 3)}
          >
            {t('actions.seeLess')}
          </Text>
        ) : (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(Infinity)}
          >
            {linkText}
          </Text>
        )}
      </Flex>

      <Grid templateColumns={`repeat(${isDesktop ? 5 : 3}, 1fr)`} gap={5}>
        {(playlists ?? playlistFound).slice(0, maxDisplay).map((playlist) => (
          <GridItem key={playlist.id} h='115px' w='115px'>
            <Image
              objectFit='cover'
              src={`https://tsl-assets.s3.eu-west-3.amazonaws.com/playlist-covers/${playlist.coverFilename}`}
              bg='gray'
              borderRadius={5}
              cursor='pointer'
              onClick={() => setSelectedPlaylistIdValue(playlist.id)}
            />
          </GridItem>
        ))}
      </Grid>
    </Stack>
  );
}

export default Playlists;
